import React from "react";
import "./SegmentedToggle.css";

interface SegmentedToggleOption {
  value: string;
  label: string;
  icon?: React.ReactNode;
}

interface SegmentedToggleProps {
  options: SegmentedToggleOption[];
  selected: string;
  onChange: (value: string) => void;
  className?: string;
}

const SegmentedToggle: React.FC<SegmentedToggleProps> = ({
  options,
  selected,
  onChange,
  className = "",
}) => {
  return (
    <div className={`segmented-toggle-container ${className}`}>
      {options.map((option) => (
        <button
          key={option.value}
          className={`segmented-toggle-option${selected === option.value ? " selected" : ""}`}
          onClick={() => onChange(option.value)}
          type="button"
        >
          {option.icon && <span className="segmented-toggle-icon">{option.icon}</span>}
          <span className="segmented-toggle-label">{option.label}</span>
        </button>
      ))}
    </div>
  );
};

export default SegmentedToggle; 